// @givmo/compliance — the review's words (CCM-R1-REVIEW-WEB; UX slice 4's frames 91, 92, 96–100,
// 99b, 102, 102b and 106).
//
// ══ WHERE EVERY LINE COMES FROM ════════════════════════════════════════════════════════════════
//
// APPROVED by Jonathan on 2026-10-08 ("approve all" at 16:09 PDT, taken with the recommendations;
// D-CCM-51; the plan folder's `scratchpad/2026-10-08-1609-review-screens-rulings-log.md`, on
// `scratchpad/2026-10-07-ux-slice4/REVIEW-14-review-screens.html`): every line N1–N56 as written,
// each named below by its number. Only the lines these screens show are here, CHANGES', REPIN's
// and ASSIGN's (N36–N40, N48; N4, N42, N43; frames 93, 94, 94b, 101–105, 108) among them since
// their web half (cut 1008-21). N44 and N45 are the email's, served by the backend.
//
// APPROVED by Jonathan on 2026-10-09 ("go with your recs" at 07:37 PDT; D-CCM-58; the plan folder's
// `scratchpad/2026-10-09-0737-stop-tracking-rulings-log.md`, on REVIEW-19): S2 to S5, a filing
// whose tracking stopped and the panel's acts on it, below. S1 is N40's own "Stop tracking it"
// (`STOP_TRACKING`), and T1 is served.
//
// APPROVED by Jonathan on 2026-10-09 ("approve" at 09:02 PDT; D-CCM-59; the plan folder's
// `scratchpad/2026-10-09-0902-rule-change-words-rulings-log.md`, on REVIEW-24's section 1): U1-a to
// U1-e, what changed in a rule for any change, below with N37.
//
// APPROVED by Jonathan on 2026-10-09 ("approve recs" at 10:06 PDT; D-CCM-60; the plan folder's
// `scratchpad/2026-10-09-1006-review-follow-on-states-rulings-log.md`, on REVIEW-24's part 2): U19
// and U23 as drafted, U20 (b) and U28 (B), below with N43 and N2.
//
// APPROVED by Jonathan on 2026-10-13 ("approve recs" at 08:54 PDT; D-CCM-71; the plan folder's
// `scratchpad/2026-10-13-0854-review-lines-rulings-log.md`, on REVIEW-20): L2, the frame above a
// state's exception (CCM-R1-REVIEW-EXCEPTION-FRAME), below with N21; and CCM-R1-REVIEW-WEB-LINES'
// L3, N16 without "Recorded." until Save decisions, and L4, the page for someone who can only view
// before anyone has opened it, below with N16 and N46. L1 is N51's own words (`NO_DATE_YET_LINE`).
//
// REUSED, approved before and named beside each: "Needs your input", "Not supported yet", "Add a
// filing", "Save", "Change", "Correct" (D-CCM-21); "Added by your organization" (D-CCM-37 JQ2);
// "Before you first solicit in {jurisdiction}" (D-CCM-22, D-CCM-27); "Not worked out yet" and the
// AI-off upload line (D-CCM-21, frame 12). The question's Yes and No, "Show", "Hide" and the decided
// list's "and {n} more" are on the approved frames. SERVED, and shown as served: the refusals (R1,
// R2, R4, R5, R6 under "Can’t do that"; D-CCM-37), row E1's online sentence (D-CCM-51's choice 5),
// the filings' names, the sources' quoted words and their citations, and a condition's own words
// where no line below words it.
//
// ONE COMPOSITION, two approved lines joined (the orchestrator's Q6, 2026-10-08 16:55 PDT): N41
// with N56's "through {Name}’s AI", for a filing a connected AI added through the review (P2).
// Two more (cut 1008-29): U23's row for a third teammate, "{item} · {Asker} asked {Name} on {date} ·
// Withdraw", U23's row with U20 (b)'s line (the orchestrator's Q2, 2026-10-09 16:13 PDT); and N2's
// count with all three of its phrases, "1 filing, 4 questions and 2 changes to filings on your
// calendar", joined "a, b and c" as U1-e's words are. One more (cut 1008-40): L2's card in the
// decisions card, named as frame 97 names every question card, by its title without the colon and
// its first words quoted, "{State} asks whether your organization is one of these “{words}…”" (the
// orchestrator's D3, 2026-10-13 12:32 PDT).
//
// No line here states what the organization must do, claims coverage, or says anything about fees
// (plan §3 rows 8 and 20; `compliance-copy-law.test.ts`), beyond U1-e's naming that a rule's fee
// changed.
//
// D-CCM-99 (Jonathan 2026-10-16 11:55 PDT, "agree"; CCM-R1-UNNAMED-PERSON-MIDSENTENCE): a person
// the roster can't name reads "someone in your organization", lowercase, wherever a line here puts
// them mid-sentence; each such function takes the roster's answer and says who itself.
//
// APPROVED by Jonathan on 2026-10-17 ("1) approved" at 07:17 PDT, taken with the recommendations;
// D-CCM-102; the plan folder's `scratchpad/2026-10-17-0717-ask-words-and-record-field-rulings-log.md`,
// on `scratchpad/2026-10-17-cut-1008-80-design/review-45/REVIEW-45-ask-words-and-record-field.html`):
// N-U23, U23's line with a colon before the asker's note (CCM-R1-REVIEW-ASK-NOTE-SEEN), and every
// line naming one ask a connected AI made, in D-CCM-96's one form, "through {Name}’s AI", or "through
// a connected AI" where Givmo can't name the person (CCM-R1-REVIEW-ASK-VIA-AI), each marked where it
// is written.
//
// APPROVED by Jonathan on 2026-10-18 ("approve recs" at 07:46 PDT, taken with the recommendations;
// D-CCM-108; the plan folder's `scratchpad/2026-10-18-0746-maryland-review-words-rulings-log.md`, on
// `scratchpad/2026-10-18-cut-1008-92-design/REVIEW-47-md-records-and-online-question.html`): W1,
// W1-a, W2, W2-a, W2-b, W3, W3-a, R, S, E and F, Maryland's records on the review's cards and its
// online question, below; and a rule with no display title named by its served citation
// (`filingTitle`, REVIEW-47's choice 2).
//
// APPROVED (D-CCM-112, Jonathan 2026-10-18 18:13 PDT, "approve recs"): RF1, RQ1 and RQ2 for a
// registration statement sent (cut 1008-90's design stop §5, as drafted), the register's own record
// of a filing as a fact and its question, below, which Maryland's annual report reads
// (CCM-R1-ASSESS-REGISTER-FACT-C). RF1's and RQ1's confirmed forms, and the annual report's and the
// exemption's nouns, stay PENDING Jonathan (cut 1008-90's review, F5; review-191, F4).
//
// APPROVED by Jonathan on 2026-10-22 ("approve" at 09:03 PDT; D-CCM-117; the plan folder's
// `scratchpad/2026-10-22-0903-solicits-outside-words-rulings-log.md`, on
// `scratchpad/2026-10-22-cut-1008-106-design/review-o1-k1.html`): O1, the name of whether an
// organization asks in a state other than one, drafted at cut 1008-106's design stop, below.
// D-CCM-114 (2026-10-22 07:13 PDT, "yes") ruled the reading it names.
//
// PENDING Jonathan (cut 1008-125, CCM-R1-FACTS-WEB-FIGURE-CARD): cut 1008-20's W1, W2 and W3 as it
// drafted them, Maryland's $25,000 figure over a fiscal year not yet over (its question, its line
// and its fact), below with N20, N49 and N54 (not the W1–W3 of Maryland's records further down).
//
// PENDING Jonathan (cut 1008-125, CCM-R1-FACTS-WEB-VALUE-TYPE-GUARD): RF-p, the register's record of
// one year's filing as a fact (the backend's RF-p, PENDING since cut 1008-122, in the web's dates),
// below with RF1.
//
// PENDING Jonathan (cut 1008-125, review-218's fold): W2 and W3 as revised, each naming the day its
// figure is counted through, as the backend's W6 does; and RF1-b, RF1 for a filing sent each year,
// "sent to {state} before", so it reads apart from that filing's year (RF-p); its confirmed form is as
// drafted. Both below with N49, N54 and RF1.
//
// SERVED, and PENDING Jonathan on the backend since cut 1008-122, each shown as served: Givmo's own
// question (`module_words`, W5) and the record's name for it (W5-r, its condition's `words` and a
// reading's `module_name`), and W4, what a result's line leaves open (`open_detail`), beside the
// result it qualifies.

import { SOMEONE_IN_YOUR_ORGANIZATION_MID_SENTENCE } from './compliance-signing-model';

// ── The way in (N1–N3) ──────────────────────────────────────────────────────────────────────────

/** N1: the card's title and the page's. */
export const REVIEW_TITLE = 'Review what Givmo found';

/** N2: the card's line. `found` is "4 questions", "1 filing and 4 questions" and the like. */
export function reviewCardLine(found: string, total: number): string {
  return `${found} ${total === 1 ? 'is' : 'are'} waiting for you.`;
}
/** U28 (B): N2's phrase for the changes to filings on the calendar. */
export function changesToFilings(count: number): string {
  return count === 1
    ? '1 change to a filing on your calendar'
    : `${count} changes to filings on your calendar`;
}

/** N3: the card's button. */
export const REVIEW_BUTTON = 'Review';

// ── The page (N5–N16, N47, N50, N51) ───────────────────────────────────────────────────────────

/** N5, under the page's title. */
export function reviewLead(ruleCount: number, asOf: string): string {
  return `Givmo compared your recorded facts with the ${ruleCount} ${ruleCount === 1 ? 'rule' : 'rules'} it evaluates, as of ${asOf}. Nothing goes on your calendar until you save your decisions.`;
}

/** N6: the section titles. "Needs your input" and "Not supported yet" are D-CCM-21's. */
export const SECTION_CHANGES = 'Changes to filings on your calendar';
export const SECTION_FILINGS = 'Filings identified';
export const SECTION_QUESTIONS = 'Needs your input';
export const SECTION_ISSUES = 'Not settled by the rules';
export const SECTION_NO_FILING = 'No filing';
export const SECTION_NOT_SUPPORTED = 'Not supported yet';

/** N7, a filing identified. */
export const MEETS_CONDITIONS = 'Your recorded facts meet this rule’s conditions.';

/** N8: the facts a result read. "Correct" is D-CCM-21's. */
export const BASED_ON = 'Based on';
export const CORRECT = 'Correct';

/** N9: the opened basis, and each condition's outcome. */
export const SHOW_HOW = 'Show how Givmo got this';
export const HIDE_HOW = 'Hide how Givmo got this';
export const OUTCOME_WORDS: Readonly<Record<string, string>> = {
  met: 'met',
  not_met: 'not met',
  unknown: 'not known',
};

/** N50, at the opened basis's foot. */
export function evaluatedOn(day: string): string {
  return `Evaluated on ${day}, from the facts recorded then.`;
}

/** N10: a filing's choices. */
export const ADD_TO_CALENDAR = 'Add to calendar';
export const NOT_FILING = 'Not filing';
export const WHY_OPTIONAL = 'Why? (optional)';
export const WHY_PLACEHOLDER = 'For your records';

/** N47 (choice 1): the filings section's one shortcut. */
export function addAllLabel(count: number): string {
  return `Add all ${count} to calendar`;
}

/** N11: a filing already tracked. */
export const ALREADY_ON_CALENDAR = 'Already on your calendar';
export const OPEN_THE_FILING = 'Open the filing';

/** N51, a filing with no date yet, beside "Add to calendar". */
export const NO_DATE_YET = 'Givmo doesn’t have a date for this yet.';

/** The panel's date leads: D-CCM-21's and slices 2 and 3's (D-CCM-22, D-CCM-27). */
export const NOT_WORKED_OUT_YET = 'Not worked out yet';
export function beforeFirstSolicit(jurisdiction: string): string {
  return `Before you first solicit in ${jurisdiction}`;
}

/** N12, a no-filing result another rule's conditions decide. */
export function meetsConditionsOf(filing: string): string {
  return `Your recorded facts meet the conditions of ${filing}, so this rule calls for no filing.`;
}

/** N13, a no-filing result, opened. */
export const CONDITIONS_NOT_MET = 'Your recorded facts don’t meet this rule’s conditions.';

/** D-CCM-19 (Jonathan, 2026-09-29 10:05 PDT): a met exemption's own label, never "Rule excluded". */
export const CONDITIONS_MET_NO_FILING = 'Conditions met — this rule calls for no filing';

/** N14, the folded no-filing list, and its toggle. */
export function moreNotMet(count: number, more: boolean): string {
  return `${count}${more ? ' more' : ''} ${count === 1 ? 'rule' : 'rules'} whose conditions your facts don’t meet`;
}
export const SHOW = 'Show';
export const HIDE = 'Hide';

/** N15: the choices on a no-filing result. */
export const THATS_RIGHT = 'That’s right';
export const WE_FILE_IT = 'We file it';

/**
 * L3 (D-CCM-71): N16 without "Recorded.", after "We file it" until Save decisions, above D-CCM-21's
 * "Add a filing". Nothing is recorded before the save, and after it the decided list says what was.
 */
export const WE_FILE_IT_CHOSEN =
  'Givmo’s result stays as it is. To track this filing, add it yourself.';
export const ADD_A_FILING = 'Add a filing';

/** D-CCM-37 JQ2 (A): the label a filing added after "We file it" goes on with. */
export const ADDED_BY_YOUR_ORGANIZATION = 'Added by your organization';

// ── Questions (N17–N23, N52, N53) ──────────────────────────────────────────────────────────────

/** N17. */
export function whereAsks(org: string): string {
  return `Where does ${org} ask for contributions?`;
}
/**
 * S1 (D-CCM-72; REVIEW-21): the organization's statement that its list of states is complete, a
 * checkbox under the list wherever it is answered or corrected.
 */
export function allOurStates(org: string): string {
  return `These are all the states where ${org} asks for contributions.`;
}
/** S2: under S1, what the statement does. */
export function otherStatesRead(org: string): string {
  return `Givmo reads every other state as one where ${org} doesn’t ask.`;
}
/** S4: the statement in S1's place while no state is chosen. */
export function asksInNoState(org: string): string {
  return `${org} doesn’t ask for contributions in any state.`;
}
/** N18. */
export function whenYearEnds(org: string): string {
  return `When does ${org}’s fiscal year end?`;
}
/** N19. */
export function engagesPaidFundraiser(org: string): string {
  return `Does ${org} engage a paid fundraiser, solicitor or fundraising consultant?`;
}
/** N20. */
export function contributionsFromPublic(org: string, period: string): string {
  return `How much did ${org} receive in charitable contributions from the public in ${period}?`;
}
/** Cut 1008-20's W1 (PENDING): N20 for a fiscal year not yet over, which N20's past tense misstates. */
export function contributionsSoFarFromPublic(org: string, day: string): string {
  return `How much has ${org} received in charitable contributions from the public so far in the fiscal year ending ${day}?`;
}
/** N21: a state's own questions, each of its descriptions quoted beneath. */
export function sourceAsks(jurisdiction: string): string {
  return `${jurisdiction} asks whether your organization:`;
}
/**
 * L2 (D-CCM-71): above a state's exception, a noun phrase such as § 6-405(a)'s, on a card of its own
 * with the state's words quoted beneath, never reworded (G2). The state's other questions keep N21.
 */
export function sourceAsksIsOneOf(jurisdiction: string): string {
  return `${jurisdiction} asks whether your organization is one of these:`;
}

/** N22, on each question. */
export function yourAnswerDecides(filings: string): string {
  return `Your answer decides: ${filings}`;
}
export const I_DONT_KNOW = 'I don’t know';
export function dontKnowYet(name: string | undefined, day: string): string {
  return `You don’t know yet · ${name ?? SOMEONE_IN_YOUR_ORGANIZATION_MID_SENTENCE}, ${day}`;
}
export const UPLOAD_A_DOCUMENT = 'Upload a document';

/** N53: "I don't know" chosen, not yet saved. */
export const YOU_DONT_KNOW = 'You don’t know yet';
export const UNDO = 'Undo';

/**
 * N52: the answer fields' placeholders. Yes, No and Save are the approved frames' (D-CCM-21); Cancel,
 * on a correction, is N42's and the profile's own form's.
 */
export const CHOOSE_STATES = 'Choose states';
export const MONTH = 'Month';
export const DAY = 'Day';
export const YES = 'Yes';
export const NO = 'No';
export const SAVE = 'Save';
export const CANCEL = 'Cancel';

/** N23, after an upload or an answer. AI off shows frame 12's approved line instead (D-CCM-21). */
export function uploadedNotRead(file: string): string {
  return `${file} added. Givmo doesn’t read documents yet, so answer here when you can.`;
}
export const KEPT_NOT_READ_AI_OFF =
  'Kept as uploaded. AI is off for your organization, so Givmo never reads them.';
export const ANSWER_SAVED = 'Saved. The review now uses your answer.';

// ── The register's own record of a filing (RF1, RQ1 and RQ2; CCM-R1-ASSESS-REGISTER-FACT-B). Its
// first rule is Maryland's annual report (CCM-R1-ASSESS-REGISTER-FACT-C). A filing with no noun here
// keeps the served words. APPROVED (D-CCM-112, Jonathan 2026-10-18 18:13 PDT, "approve recs"):
// RF1, RQ1 and RQ2 for a registration statement sent, as §5 drafted them. PENDING Jonathan: RF1's
// and RQ1's confirmed forms, and the annual report's and the exemption's nouns, drafted at cut
// 1008-90's build (its review, F5; review-191, F4), which no rule reads yet. ──────────────────────

/** What an organization sends a state for each filing (`record=sent`). */
const SENT_FILING_NOUNS: Readonly<Record<string, string>> = {
  registration: 'registration statement',
  annual_report: 'annual report',
  exemption: 'exemption filing',
};
/** What the state confirms (`record=recorded`). */
const CONFIRMED_FILING_NOUNS: Readonly<Record<string, string>> = {
  registration: 'registration',
  annual_report: 'annual report',
  exemption: 'exemption',
};

function filingNoun(record: string | undefined, filingClass: string | undefined) {
  const nouns =
    record === 'sent' ? SENT_FILING_NOUNS : record === 'recorded' ? CONFIRMED_FILING_NOUNS : {};
  return filingClass !== undefined ? nouns[filingClass] : undefined;
}

function capitalized(words: string): string {
  return words.charAt(0).toUpperCase() + words.slice(1);
}

/** The filings sent for a year (`register_period_record` names that year's, RF-p). */
const YEARLY_FILING_CLASSES: ReadonlySet<string> = new Set(['annual_report', 'exemption']);

/**
 * RF1 (D-CCM-112 for a registration statement sent): the fact line's name. A filing sent for a year
 * reads RF1-b (PENDING), "… sent to {state} before", the register's record of any year's sending,
 * never one year's (RF-p). The confirmed forms are as drafted.
 */
export function registerRecordFactLabel(
  record: string | undefined,
  filingClass: string | undefined,
  jurisdiction: string,
): string | undefined {
  const noun = filingNoun(record, filingClass);
  if (noun === undefined) return undefined;
  if (record !== 'sent') return `${capitalized(noun)} confirmed by ${jurisdiction}`;
  const before =
    filingClass !== undefined && YEARLY_FILING_CLASSES.has(filingClass) ? ' before' : '';
  return `${capitalized(noun)} sent to ${jurisdiction}${before}`;
}
/** RF-p (PENDING): RF1 for one year's filing, its year ("the fiscal year ended …") after the filing. */
export function registerPeriodRecordFactLabel(
  record: string | undefined,
  filingClass: string | undefined,
  jurisdiction: string,
  year: string,
): string | undefined {
  const noun = filingNoun(record, filingClass);
  if (noun === undefined) return undefined;
  return record === 'sent'
    ? `${capitalized(noun)} for ${year} sent to ${jurisdiction}`
    : `${capitalized(noun)} for ${year} confirmed by ${jurisdiction}`;
}
/**
 * RQ1 (D-CCM-112 for a registration statement sent): the question card's title, where Givmo holds no
 * record.
 */
export function registerRecordQuestion(
  org: string,
  record: string | undefined,
  filingClass: string | undefined,
  jurisdiction: string,
): string | undefined {
  const noun = filingNoun(record, filingClass);
  if (noun === undefined) return undefined;
  return record === 'sent'
    ? `Has ${org} sent ${jurisdiction} its ${noun}?`
    : `Has ${jurisdiction} confirmed ${org}’s ${noun}?`;
}
/** RQ2 (D-CCM-112): the card's line naming where it is answered. */
export function registerRecordDoor(
  record: string | undefined,
  filingClass: string | undefined,
  jurisdiction: string,
): string | undefined {
  const noun = filingNoun('recorded', filingClass);
  if (filingNoun(record, filingClass) === undefined || noun === undefined) return undefined;
  return `Givmo reads this from your filings. If it has, record it on ${jurisdiction}’s ${noun} in Filings.`;
}

// ── What a condition reads, in words (N49, N54) ────────────────────────────────────────────────

/** N49: a personnel prong's words, where it is the one the frames show. */
export const DOES_NOT_EMPLOY_A_PROFESSIONAL_SOLICITOR = 'Does not employ a professional solicitor';
/** N49 and N54: the one measure the frames name. */
export const CONTRIBUTIONS_FROM_THE_PUBLIC = 'Contributions from the public';
/**
 * N49: "{measure}, at or below {amount}, in the fiscal year ended {date}". "At or below" is the line's
 * own words: a prong with any other comparator shows its served words instead.
 */
export function thresholdWords(measure: string, amount: string, period: string): string {
  return `${measure}, at or below ${amount}, in ${period}`;
}
/** N49 and N54: the period a figure is measured over. */
export function fiscalYearEnded(day: string): string {
  return `the fiscal year ended ${day}`;
}
/** N54: the one fact label with no served name. */
export function contributionsFactLabel(period: string): string {
  return `${CONTRIBUTIONS_FROM_THE_PUBLIC}, ${period}`;
}
/**
 * Cut 1008-20's W3 (PENDING, as revised in review-218's fold): the period of a fiscal year not yet over,
 * after N54's measure, with the day its figure is counted through where one is served.
 */
export function soFarInTheFiscalYearEnding(day: string, through?: string): string {
  const counted = through !== undefined ? `, through ${through}` : '';
  return `so far in the fiscal year ending ${day}${counted}`;
}
/** Cut 1008-20's W2 (PENDING, as revised in review-218's fold): N49 over a fiscal year not yet over. */
export function thresholdSoFarWords(
  measure: string,
  amount: string,
  day: string,
  through?: string,
): string {
  return `${measure}, at or below ${amount}, ${soFarInTheFiscalYearEnding(day, through)}`;
}

// ── Maryland's records on the review's cards, and its online question, APPROVED (D-CCM-108,
// Jonathan 2026-10-18 07:46 PDT, "approve recs"; REVIEW-47; CCM-R1-ASSESS-RULES-MDREG-WEB,
// CCM-R1-ASSESS-MD-ONLINE-SOLICITING) ──

/** W1 (D-CCM-75's own draft): where the organization is located, asked when Givmo's records hold no state. */
export function isLocatedIn(org: string, state: string): string {
  return `Is ${org} located in ${state}?`;
}
/** W1-a: under W1, why it is asked. */
export function recordsShowNoState(org: string): string {
  return `Givmo’s records don’t show a state for ${org}.`;
}
/** W2: the located fact's name, by the state's own name. */
export function locatedIn(state: string): string {
  return `Located in ${state}`;
}
/** W2-a: a located fact read from the address the IRS holds. */
export function fromTheIrsAddress(org: string): string {
  return `From the address the IRS holds for ${org}`;
}
/** W2-b: a located fact read from the state on the organization's own record in Givmo. */
export function fromGivmosRecord(org: string): string {
  return `From the state on Givmo’s record of ${org}`;
}
/** W3: the federal exemption's name. */
export const FEDERAL_TAX_EXEMPTION_IN_EFFECT = 'Federal tax-exempt status in effect';
/** W3-a: where Givmo read it. */
export const FROM_THE_IRS_LISTS = 'From the IRS’s exempt organization lists Givmo holds';
/** R (review-182's F2): in N13's place, a no-filing Givmo's records alone decide. */
export const RECORDS_DONT_MEET_CONDITIONS =
  'The facts in Givmo’s records don’t meet this rule’s conditions.';
/** S: Givmo's copy of the IRS lists past its freshness rule, which nothing the organization answers settles. */
export const IRS_LISTS_OUT_OF_DATE =
  'Givmo’s copy of the IRS lists is out of date. This waits until the copy is current.';
/** E: before a source's own example, beside its question. */
export function anExampleStateGives(state: string): string {
  return `An example ${state} gives:`;
}
/** F: frame 34's caption, with the form named, over the form's own fee chart. */
export function feeChartFromForm(state: string, page: number, form: string): string {
  return `${state}’s fee chart, from page ${page} of ${form}`;
}

// ── Asking in a state other than one, read from the states list (CCM-R1-FACTS-SOLICITS-OUTSIDE-B,
// Maryland's § 6-401(a)(3); D-CCM-114). APPROVED (D-CCM-117): O1. ─────────────────────────────────

/** O1: the fact's name, the state by its own name. It is answered on the states list (N17). */
export function solicitsInAnotherState(state: string): string {
  return `Solicits contributions in a state other than ${state}`;
}

// ── Evidence a source may ask for (N24, J1) ────────────────────────────────────────────────────

/** N24's lead, before the source's own sentence and its citation (both served). */
export function mayAskForEvidence(jurisdiction: string): string {
  return `${jurisdiction} may ask for evidence of this:`;
}

// ── Not settled (N25, N55) ─────────────────────────────────────────────────────────────────────

/** N55: the unsettled online question's title. Its sentence is served (choice 5). */
export const ASKING_ONLINE = 'Asking for contributions online';
/** N25. */
export function leavesUnresolved(list: string): string {
  return `It leaves these unresolved: ${list}`;
}
export const FOR_ORG_OR_COUNSEL =
  'Givmo can’t settle this. Your organization, or its counsel, can.';
export const DECIDE_LATER = 'Decide later';

// ── Not supported (N26, N27) ───────────────────────────────────────────────────────────────────

/** N26. */
export function notEvaluatedLine(count: number): string {
  return `Givmo doesn’t evaluate ${count} ${count === 1 ? 'rule' : 'rules'} in its library yet, so this review says nothing about them.`;
}
export const IN_PLACES_TOLD = 'In places you’ve told Givmo about:';
export const SHOW_ALL = 'Show all';

/** N27 (frame 106): before any rule evaluates. */
export const NOTHING_EVALUATES =
  'Givmo doesn’t evaluate any rules for your organization yet, so this review says nothing about which filings apply. Add the filings you know, and Givmo keeps their dates.';

// ── Your decisions (N28–N31, N46, N56) ─────────────────────────────────────────────────────────

/** N28. */
export const YOUR_DECISIONS = 'Your decisions';
export const NOTHING_CHOSEN = 'Nothing chosen yet. Choose on each item, then save once.';
/** N29, above the act. */
export const ADDING_DOESNT_FILE = 'Adding a filing to your calendar doesn’t file or send anything.';
/** N30. */
export const SAVE_DECISIONS = 'Save decisions';
/** N46, in place of the button for someone who can only view. */
export const VIEWER_CANT_SAVE =
  'Only people who can make changes in Compliance can save decisions.';
/**
 * L4 (D-CCM-71): the page for someone who can only view, before anyone has opened the review. It says
 * why the page is empty and what changes that; N46 waits for a review to act on.
 */
export const REVIEW_NOT_MADE_YET =
  'There’s no review yet. Givmo makes one when someone who can make changes in Compliance opens this page.';

/**
 * N31: "Saved. {3 decisions} recorded. {1 item is} still open." With nothing left open its second
 * sentence has nothing to say, so the line is its first sentence alone.
 */
export function savedLine(decided: number, open: number): string {
  const recorded = `Saved. ${decided} ${decided === 1 ? 'decision' : 'decisions'} recorded.`;
  if (open === 0) return recorded;
  return `${recorded} ${open} ${open === 1 ? 'item is' : 'items are'} still open.`;
}
export const DECIDED = 'Decided';
export const DECIDED_EARLIER = 'Decided earlier';
export const CHANGE = 'Change';
export function decidedLine(choice: string, name: string | undefined, day: string): string {
  return `${choice} · ${name ?? SOMEONE_IN_YOUR_ORGANIZATION_MID_SENTENCE}, ${day}`;
}
/** N56: a decision the organization's connected AI recorded; "a connected AI" where Givmo can't name the person. */
export function decidedThroughAiLine(
  choice: string,
  name: string | undefined,
  day: string,
): string {
  return `${choice} · through ${name !== undefined ? `${name}’s AI` : 'a connected AI'}, ${day}`;
}

// ── Re-presentation and standing decisions (N32–N35) ───────────────────────────────────────────

/** N32: the reason under R1 (which is served), when the review changed. */
export function savedMeanwhile(name: string, time: string): string {
  return `${name} saved decisions on it at ${time}.`;
}
export const REASON_RULES = 'A rule was updated.';
export const REASON_FACTS = 'A recorded fact changed.';
export const REASON_CALENDAR = 'A filing on your calendar changed.';
export const REASON_SUPERSEDED = 'There’s a newer review.';

/** N33. */
export const SHOW_UPDATED = 'Show the updated review';
export const MARK_NEW = 'New';
export const MARK_CHANGED = 'Changed';
export const CHOICES_KEPT = 'Your choices were kept where an item didn’t change.';

/** N34: another person's addition. */
export function addedByAt(name: string | undefined, time: string): string {
  return `Added to your calendar by ${name ?? SOMEONE_IN_YOUR_ORGANIZATION_MID_SENTENCE} at ${time}`;
}

/** N35 (JQ1 (A), D-CCM-37): a "Not filing" back for a decision. */
export function chosenNotToFile(
  day: string,
  name: string | undefined,
  cause: 'facts' | 'rule',
): string {
  return `You chose not to file this on ${day} (${name ?? SOMEONE_IN_YOUR_ORGANIZATION_MID_SENTENCE}). ${
    cause === 'facts' ? 'The facts it rested on changed since' : 'The rule changed since'
  }, so it’s here again.`;
}

// ── A filing on the calendar that reads otherwise (N36–N40, N48; frames 101–105) ───────────────

/** N36: a rule updated since the filing was pinned to it (the review's change card, the panel). */
export function thisRuleUpdatedOn(day: string): string {
  return `This rule was updated on ${day}.`;
}
/** N36's link, which opens N37's comparison ("Hide" closes it, as on frames 101 and 103). */
export const SEE_WHAT_CHANGED = 'See what changed';
/** N37: the comparison, its rows "Extension" (N37) and "Due date" (U1-a). */
export const WHAT_CHANGED = 'What changed';
export const BEFORE = 'Before';
export const NOW = 'Now';
export const EXTENSION = 'Extension';
/** U1-a: the row for a due date the update moved, added or removed: each version's date. */
export const DUE_DATE = 'Due date';
/** N48: a comparison's "before" when the older rule had nothing; U1-b: its "now" when the updated
 * rule no longer has it. */
export const NOT_IN_GIVMOS_RULE = 'Not in Givmo’s rule';
/** U1-c: under the table, what else the update changed ("wording and sources"). */
export function alsoUpdatedRule(items: string): string {
  return `Givmo also updated this rule’s ${items}.`;
}
/** U1-d: in place of the table, when the update moved no date. */
export function updatedRuleSameDates(items: string): string {
  return `Givmo updated this rule’s ${items}. The dates it works out for this filing stay the same.`;
}
/**
 * R2, APPROVED (D-CCM-107, Jonathan 2026-10-17 19:29 PDT, "approve recs"; CCM-OPS1-REPIN-EVERY-YEAR):
 * U1-e's word for a due date the update changed that moves none of this filing's years. It comes
 * first in U1-c's and U1-d's list ("Givmo updated this rule’s due date and sources. The dates it
 * works out for this filing stay the same.").
 */
export const DUE_DATE_ITEM = 'due date';
/** U1-e: each change with no date to show, by the backend's aspect, in this order. Joined "a, b and
 * c" in U1-c and U1-d. */
export const RULE_ASPECT_WORDS: readonly (readonly [aspect: string, word: string])[] = [
  ['wording_changed', 'wording'],
  ['sources_changed', 'sources'],
  ['fees_changed', 'fee'],
  ['forms_changed', 'forms'],
  ['conditions_changed', 'conditions'],
  ['channels_changed', 'how it’s sent'],
  ['other', 'other details'],
];
/** N38: the comparison's choice (choice 2), and its line. */
export const USE_UPDATED_RULE = 'Use the updated rule';
export const USE_UPDATED_RULE_LINE =
  'Givmo works out this filing’s dates from the updated rule. Its history stays as it is.';
export const LATER = 'Later';
/** N39: after the update, from its event (frame 104). */
export function updatedToRule(ruleDay: string, name: string | undefined, day: string): string {
  return `Updated to the rule as of ${ruleDay} by ${name ?? SOMEONE_IN_YOUR_ORGANIZATION_MID_SENTENCE} on ${day}.`;
}
/**
 * N56's naming of the person's connected AI, as every line that names one act says it (D-CCM-96):
 * "{Name}’s AI", or "a connected AI" where Givmo can't name the person.
 */
export function throughTheirAi(name: string | undefined): string {
  return name !== undefined ? `${name}’s AI` : 'a connected AI';
}
/** N39 for an update made through the person's connected AI (D-CCM-96, frame A2). */
export function updatedToRuleThroughAi(
  ruleDay: string,
  name: string | undefined,
  day: string,
): string {
  return `Updated to the rule as of ${ruleDay} through ${throughTheirAi(name)} on ${day}.`;
}
/** N40's first line, when another rule's met conditions are why. */
export function nowMeetsConditionsOf(filing: string): string {
  return `Your recorded facts now meet the conditions of ${filing}, so this rule calls for no filing.`;
}
/** N40's first line for any other reason. */
export function nowReadsNoFiling(reason: string): string {
  return `Givmo’s rules now read this as no filing: ${reason}`;
}
/** N40's choices (choice 2), and the line under "Stop tracking it". */
export const KEEP_TRACKING = 'Keep tracking it';
export const STOP_TRACKING = 'Stop tracking it';
export const STOP_TRACKING_LINE = 'Its history stays. Givmo stops showing new dates for it.';

// ── Asking a teammate (N4, N42, N43, N52; frames 93, 94, 94b, 108) ─────────────────────────────

/** N42: the link on every open item, and the dialog's title. */
export const ASK_A_TEAMMATE = 'Ask a teammate';
export const ASK_WHO = 'Who';
/** N52: the empty "Who". */
export const CHOOSE_A_PERSON = 'Choose a person';
export const ASK_NOTE = 'A note (optional)';
export const ASK_ACCESS_LINE = 'Only people who can make changes in Compliance can be asked.';
export const ASK = 'Ask';
/** N43: after asking (frame 94), and to the person asked (frame 94b). */
export function askedOn(name: string | undefined, day: string): string {
  return `Asked ${name ?? SOMEONE_IN_YOUR_ORGANIZATION_MID_SENTENCE} on ${day}`;
}
export const WITHDRAW = 'Withdraw';
export function askedYouAboutThis(name: string, day: string): string {
  return `${name} asked you about this on ${day}:`;
}
/** U19: the person asked, when the ask came with no note: N43's line with a period for its colon. */
export function askedYouAboutThisNoNote(name: string, day: string): string {
  return `${name} asked you about this on ${day}.`;
}
/**
 * U20 (b): who asked whom, for anyone but the asker and the person asked (U21 follows it). The
 * asker opens the line, so the caller passes their capitalized form; the person asked is mid-line.
 */
export function someoneAsked(asker: string, name: string | undefined, day: string): string {
  return `${asker} asked ${name ?? SOMEONE_IN_YOUR_ORGANIZATION_MID_SENTENCE} on ${day}`;
}
/** U23: last on the review, the open asks on items it doesn't show now. */
export const NOT_IN_THIS_REVIEW = 'Not in this review right now';
/** U23: the person asked, under that heading. */
export function askedYouAboutItem(name: string, item: string, day: string): string {
  return `${name} asked you about ${item} on ${day}.`;
}
/**
 * N-U23, APPROVED (D-CCM-102, Jonathan 2026-10-17 07:17 PDT, "1) approved";
 * CCM-R1-REVIEW-ASK-NOTE-SEEN): U23's line for the person asked with a colon for its period, before
 * the asker's note: U19's rule, read the other way.
 */
export function askedYouAboutItemWithNote(name: string, item: string, day: string): string {
  return `${name} asked you about ${item} on ${day}:`;
}
/** N4: the card of the person asked (frame 108). */
export function askedYouAbout(name: string, items: number): string {
  return `${name} asked you about ${items} ${items === 1 ? 'item' : 'items'}.`;
}

// ── An ask made through the asker's connected AI, APPROVED (D-CCM-102, Jonathan 2026-10-17
// 07:17 PDT, "1) approved"; CCM-R1-REVIEW-ASK-VIA-AI): D-CCM-96's one form, N56's "through
// {Name}’s AI", in every line that names one ask. To the person asked, the sentence turns on "you";
// to everyone else, one line. ──

/** 94b's line, through the asker's AI, before its note. */
export function askedYouAboutThisThroughAi(asker: string | undefined, day: string): string {
  return `You were asked about this through ${throughTheirAi(asker)} on ${day}:`;
}
/** The same with no note: a period for its colon, as U19's. */
export function askedYouAboutThisThroughAiNoNote(asker: string | undefined, day: string): string {
  return `You were asked about this through ${throughTheirAi(asker)} on ${day}.`;
}
/** N-U23's line, through the asker's AI, before its note. */
export function askedYouAboutItemThroughAi(
  asker: string | undefined,
  item: string,
  day: string,
): string {
  return `You were asked about ${item} through ${throughTheirAi(asker)} on ${day}:`;
}
/** U23's line for the person asked, through the asker's AI, with no note. */
export function askedYouAboutItemThroughAiNoNote(
  asker: string | undefined,
  item: string,
  day: string,
): string {
  return `You were asked about ${item} through ${throughTheirAi(asker)} on ${day}.`;
}
/** N43's and U20 (b)'s line for everyone but the person asked, through the asker's AI. */
export function askedThroughAi(
  name: string | undefined,
  asker: string | undefined,
  day: string,
): string {
  return `Asked ${name ?? SOMEONE_IN_YOUR_ORGANIZATION_MID_SENTENCE} through ${throughTheirAi(asker)} on ${day}`;
}

// ── A filing whose tracking stopped (D-CCM-58: S2 to S5) ───────────────────────────────────────

/** S3: a stopped filing's panel, under "No longer tracked", whichever way it was stopped. */
export function trackingStoppedBy(name: string | undefined, day: string): string {
  return `Tracking stopped by ${name ?? SOMEONE_IN_YOUR_ORGANIZATION_MID_SENTENCE} on ${day}.`;
}
/** S3 for a stop made through the person's connected AI (D-CCM-96, frame A3). */
export function trackingStoppedThroughAi(name: string | undefined, day: string): string {
  return `Tracking stopped through ${throughTheirAi(name)} on ${day}.`;
}
/** S2: the confirmation's title, over the filing's panel. Its body is N40, its buttons 105's. */
export function stopTrackingTitle(filing: string): string {
  return `Stop tracking ${filing}?`;
}
/** S4: the stopped filing's restart, under "No longer tracked". It acts at once. */
export const START_TRACKING_AGAIN = 'Start tracking it again';
/** S5: the review, finding a stopped filing again, in the place and voice of N35. */
export function youStoppedTracking(day: string, name: string | undefined): string {
  return `You stopped tracking this on ${day} (${name ?? SOMEONE_IN_YOUR_ORGANIZATION_MID_SENTENCE}).`;
}
/** S5 for a stop made through the person's connected AI (D-CCM-96). */
export function youStoppedTrackingThroughAi(day: string, name: string | undefined): string {
  return `You stopped tracking this on ${day} (through ${throughTheirAi(name)}).`;
}

// ── The filing's panel (N41, and P2's composition with N56) ────────────────────────────────────

/** N41: a filing the review put on the calendar. */
export function addedFromReview(day: string, name: string | undefined): string {
  return `Added to your calendar from your review on ${day}, by ${name ?? SOMEONE_IN_YOUR_ORGANIZATION_MID_SENTENCE}.`;
}
/** N41 joined with N56's words: a filing the organization's connected AI added through the review. */
export function addedFromReviewThroughAi(day: string, name: string | undefined): string {
  return `Added to your calendar from your review on ${day}, through ${
    name !== undefined ? `${name}’s AI` : 'a connected AI'
  }.`;
}
